import {Component, OnInit, ViewChild} from '@angular/core';
import {SectionBase} from '../../../components/section/section-base';
import {InsurerDataFormStateService} from '../../../../core/services/impl/section-services/insurer-data/insurer-data-form-state.service';
import {PhoneFieldComponent} from '../../../components/fields/telephone-number-field/telephone-number-field.component';
import {InsurerDataSectionConfig} from './insurer-data-section.config';
import {AbstractControl, FormArray, FormGroup} from '@angular/forms';
import {isNullOrUndefined} from 'util';
import {InsurerDataMode} from './insurer-data-mode-config';
import {InsurerDataSectionModeConfig} from './insurer-data-section-mode.config';
import {ContactDataConsts} from '../../../../core/consts/contact-data.consts';
import {PredefinedValuesStateService} from '../../../../core/services/impl/section-services/predefined-values/predefined-values-state.service';
import {CoOwnerModel} from '../../../../core/models/owner-data/co-owner.model';
import {FormConfig} from '../../../models/form-config';
import {FormFactoryService} from '../../../services/form-factory.service';
import {ContactInsurerDataSectionComponent} from '../contact-insurer-data-section/contact-insurer-data-section.component';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {InsurerDataConsts} from '../../../../core/consts/insurer-data.consts';
import {SeparateInsurerDataSectionComponent} from '../separate-insurer-data-section/separate-insurer-data-section.component';
import {InsuranceCompanyApiService} from '../../../../core/services/insurance-company-api.service';
import {RegExpService} from '../../../services/reg-exp.service';

@Component({
  selector: 'app-insurer-data-section',
  templateUrl: './insurer-data-section.component.html',
  styleUrls: ['./insurer-data-section.component.scss']
})
export class InsurerDataSectionComponent extends SectionBase implements OnInit {

  @ViewChild('phoneField') phoneField: PhoneFieldComponent;
  @ViewChild('contactInsurerDataSection') contactInsurerDataSection: ContactInsurerDataSectionComponent;
  @ViewChild('separateInsurerDataSection') separateInsurerDataSection: SeparateInsurerDataSectionComponent;

  coownersAmount: number;
  coOwnersList: CoOwnerModel[];
  insurerDataSectionConfig: InsurerDataSectionConfig;
  consts = {
    ...ContactDataConsts,
    ...InsurerDataConsts,
  };
  public ownerFormArray: FormArray = new FormArray([]);
  public ownerFormService: FormFactoryService;
  public coOwnersFormArray: FormArray = new FormArray([]);
  public coOwnersFormServices: FormFactoryService[] = [];

  get isDictionaryMode(): boolean {
    return this.insuranceCompanyApiService.modeConfig.mode === InsurerDataMode.DICTIONARY;
  }

  constructor(public stateService: InsurerDataFormStateService,
              private predefinedState: PredefinedValuesStateService,
              private insuranceCompanyApiService: InsuranceCompanyApiService,
              private regExpService: RegExpService) {
    super();
    this.initDataSectionModeConfig();
    this.coOwnersList = this.stateService.coownersData;
    this.coownersAmount = this.coOwnersList.length;
    this.insurerDataSectionConfig = new InsurerDataSectionConfig(stateService, regExpService);
  }

  ngOnInit() {
    this.stateService.initCoOwners();
    this.stateService.initContactDataFromCalculation();
    if (this.isDictionaryMode) {
      this.stateService.initAddressDataDictionaries();
    }
    this.createOwnerAddressDataFormGroup();
    this.createCoOwnersAddressDataFormGroup();
    this.handleFillFormEvent();
  }

  createOwnerAddressDataFormGroup(): void {
    let ownerForm = new FormGroup({});
    let ownerFormBean;
    if (!isNullOrUndefined(this.stateService.registrationData.owner)) {
      ownerFormBean = {
        ...this.stateService.registrationData.owner,
        ...this.stateService.registrationData.contact
      };
    }

    let ownerConfig: FormConfig = this.insurerDataSectionConfig.createFormConfig(false);
    let formService;
    if (ownerFormBean) {
      formService = new FormFactoryService(ownerConfig, ownerFormBean);
    } else {
      formService = new FormFactoryService(ownerConfig);
    }
    formService.buildFormGroup(ownerForm);
    /**
     * fix for autofilling third step
     */
    this.formConfig = ownerConfig;
    this.formGroup = ownerForm;

    this.ownerFormArray.push(ownerForm);
    this.ownerFormService = formService;
  }

  createCoOwnersAddressDataFormGroup(): void {
    for (let i = 0; i < this.coownersAmount; i++) {
      let coownerForm = new FormGroup({});
      let coownerFormBean = {};

      if (!isNullOrUndefined(this.stateService.coownersRegistrationData[i])) {
        coownerFormBean = this.stateService.coownersRegistrationData[i];
      }
      coownerFormBean['pesel'] = this.coOwnersList[i].pesel;
      let coownerConfig: FormConfig = this.insurerDataSectionConfig.createFormConfig(false);
      let formService;
      if (coownerFormBean) {
        formService = new FormFactoryService(coownerConfig, coownerFormBean);
      } else {
        formService = new FormFactoryService(coownerConfig);
      }
      formService.buildFormGroup(coownerForm);

      this.coOwnersFormArray.push(coownerForm);
      this.coOwnersFormServices.push(formService);
    }
  }

  fillForm(data: any) {
    super.fillForm(data);
    // if (data.stepKey === StepKey.THIRD_STEP && this.sectionDataMock.coOwners) {
    //   let control, key, value;
    //   const coOwnersAmount = this.sectionDataMock.coOwners.length;
    //   const sectionDataMock = this.sectionDataMock;
    //   for (let i = 0; i < coOwnersAmount; i++) {
    //     this.sectionDataMock = sectionDataMock.coOwners[i];
    //     this.coOwnersFormServices[i].formConfig.fieldsConfig.forEach(fieldConfig => {
    //       key = fieldConfig.fieldKey;
    //       control = this.getControlFromCoOwner(key, i);
    //       value = this.getMockValue(key);
    //       if (!isNullOrUndefined(value)) {
    //         control.setValue(value);
    //       }
    //     });
    //   }
    // }
  }

  getControlFromCoOwner(key: string, index: number): AbstractControl {
    return this.coOwnersFormArray.at(index)['controls'][key];
  }

  public initControlsChanges() {
  }

  initBean() {
  }

  createConfig() {
  }

  public get valid(): boolean {
    const valid = this.isSectionValid() && this.contactInsurerDataSection.isSectionValid();
    return this.stateService.separateInsurer ? valid && this.separateInsurerDataSection.isSectionValid() : valid;
  }

  public isSectionValid(): boolean {
    let valid: boolean = true;
    valid = this.ownerFormService.formGroup.valid;
    this.coOwnersFormServices.forEach(factory => {
      if (!factory.formGroup.valid) {
        valid = false;
      }
    });

    return valid;
  }

  public submitSection(): void {
    this.ownerFormService.submitForm();

    if (this.coOwnersFormServices.length > 0) {
      this.coOwnersFormServices.forEach(factory => {
        factory.submitForm();
      });
    }

    if (isNotNullOrUndefined(this.contactInsurerDataSection)) {
      this.contactInsurerDataSection.submitSection();
    }

    if (isNotNullOrUndefined(this.separateInsurerDataSection)) {
      this.separateInsurerDataSection.submitSection();
    }
  }

  public areErrors(): boolean {
    if (!isNullOrUndefined(this.coOwnersFormServices) && !isNullOrUndefined(this.ownerFormService)) {
      let areErrors = super.areErrors();
      let errorsCount = areErrors ? 1 : 0;

      if (this.ownerFormService.errorsMap.size !== 0) {
        errorsCount++;
      }

      this.coOwnersFormServices.forEach(factory => {
        if (factory.errorsMap.size !== 0) {
          errorsCount++;
        }
      });
      return errorsCount !== 0;
    }
    return false;
  }

  markAsDirty(event) {
    this.predefinedState.isDirtyBean = event;
  }

  private initDataSectionModeConfig(): void {
    const configBuilder = new InsurerDataSectionModeConfig(this.stateService.insuranceCompanyCode);
    this.insuranceCompanyApiService.modeConfig = configBuilder.getConfig();
    this.stateService.init();
  }
}

